export const privacy_notice = "https://smart-energy-broker.com/datenschutz";
export const terms_of_use = "https://smart-energy-broker.com/agb";
export const imprint = "https://smart-energy-broker.com/impressum";
export const docs = "https://smart-energy-broker.com";
export const app_store_id = "";
export const play_store_link = "https://play.google.com/store/apps/details?id=com.tinkerforge.seb";
